// A place for code that just needs to run when the app starts up. Should be executed immediately, before any components
// mount or render. Full of side effects!

import * as detect from 'helpers/detect';
import * as analytics from 'helpers/analytics';
import { deferInstallPrompt } from 'helpers/pwaInstall';



function startup() {

	analytics.init();

	deferInstallPrompt();

	// Remove <noscript> so it's never shown on static builds
	const noJSEl = document.getElementById('no-js-warning');
	if (noJSEl) {
		noJSEl.parentNode.removeChild(noJSEl);
	}

	// Depending on input type, some visual features should be enabled/disabled. This is accomplished with CSS selectors,
	// meaning classes must be added to the <body>.

	// Disable/Enable focus outlines depending on input types:
	// - Mobile devices should never see focus outlines
	// - Mouse users should not see focus outlines
	// - Keyboard users on desktops should see focus outlines
	// - When switching from mouse to keyboard, focus outlines should appear, and vice-versa

	// Mouse users should get :hover effects, touch users should not.

	// Pass true to turn outlines on, and false to turn them off
	function toggleFocusOutlines(toggle) {
		document.body.classList.toggle('enable-focus', toggle);
	}

	// Pass true to enable touch mode, false to disable
	function toggleTouchMode(toggle) {
		// negating due to fact that :hover is applied when input is not touch-based
		document.body.classList.toggle('no-touch', !toggle);
	}

	// Immediately apply settings for mobile devices (assume touch input is default)
	if (detect.mobile) {
		toggleFocusOutlines(false);
		toggleTouchMode(true);
	}
	// If not mobile
	else {
		// Apply settings assuming mouse/keyboard usage
		toggleFocusOutlines(true);
		toggleTouchMode(false);
		// Only try to detect input changes that affect outlines on non-mobile.
		// Listen for mousedown events to determine mouse usage and hide outlines
		window.addEventListener('mousedown', toggleFocusOutlines.bind(null, false));
		// Listen for keyboard events to show outlines
		window.addEventListener('keydown', toggleFocusOutlines.bind(null, true));
	}

	// Determine if user is using touch or mouse and apply class to <body>
	let isTouch = false;
	let lastTouchTime = 0;
	function setTouchUse(touchToggle) {
		const isTouchPrev = isTouch;

		if (touchToggle) {
			lastTouchTime = Date.now();
			isTouch = true;
		}
		else {
			// Only switch to mouse mode if a touch hasn't been detected in the last second.
			// This works around the fact that touches also generate mouse events AFTER the touch events.
			if (Date.now() - lastTouchTime > 1000) {
				isTouch = false;
			}
		}

		// Determine if input method changed
		if (isTouchPrev !== isTouch) {
			// Only keep mousemove listener when touch mode is enabled
			if (isTouch) {
				window.addEventListener('mousemove', mouseMoveHandler);
			}
			else {
				window.removeEventListener('mousemove', mouseMoveHandler);
			}

			// Toggle class
			toggleTouchMode(isTouch);
		}
	}

	const touchHandler  = setTouchUse.bind(null, true);
	const mouseMoveHandler = setTouchUse.bind(null, false);
	window.addEventListener('touchend', touchHandler);
	window.addEventListener('touchstart', touchHandler);
}

export default startup;



// WEBPACK FOOTER //
// ./src/helpers/startup.js